module.exports = __webpack_public_path__ + "static/media/1.7b936741.png";